import React from "react";
import "../Breadcrums/Breadcrum.css";
import arrow_icon from "../Assets/Frontend_Assets/breadcrum_arrow.png";

const Breadcrum = ({ product }) => {
  if (!product) return null;

  return (
    <nav className="breadcrumb-container" aria-label="breadcrumb">
      <div className="breadcrum">
        <span className="crumb">Shop</span>

        <img src={arrow_icon} alt="" className="crumb-arrow" />

        <span className="crumb">
          {product.main_category || product.category}
        </span>

        <img src={arrow_icon} alt="" className="crumb-arrow" />

        <span className="crumb active">
          {product.product_name || product.name}
        </span>
      </div>
    </nav>
  );
};

export default Breadcrum;
